// extracted by mini-css-extract-plugin
export default {"root":"DropdownBase_root__BSZv7","optionsHolder":"DropdownBase_optionsHolder__Z43dN","options":"DropdownBase_options__oUijD","has-items":"DropdownBase_has-items__bZ6XA"};